export function CollectionTabs({ collections, collView, setCollView, savedCount = 0 }) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 [&::-webkit-scrollbar]:hidden" data-testid="collection-tabs">
      <button onClick={() => setCollView(null)} data-testid="coll-tab-all"
        className={`whitespace-nowrap text-sm px-4 py-2 rounded-full ${!collView ? "bg-[#291B2D] text-white" : "bg-[#F7F2EA] text-[#291B2D]"}`}>All journeys</button>
      <button onClick={() => setCollView("featured")} data-testid="coll-tab-featured"
        className={`whitespace-nowrap text-sm px-4 py-2 rounded-full ${collView === "featured" ? "bg-[#291B2D] text-white" : "bg-[#F7F2EA] text-[#291B2D]"}`}>Featured</button>
      <button onClick={() => setCollView("saved")} data-testid="coll-tab-saved"
        className={`whitespace-nowrap text-sm px-4 py-2 rounded-full ${collView === "saved" ? "bg-[#291B2D] text-white" : "bg-[#F7F2EA] text-[#291B2D]"}`}>
        Saved{savedCount ? ` (${savedCount})` : ""}
      </button>
      {collections.map((c) => (
        <button key={c.id} onClick={() => setCollView(c.id)} data-testid={`coll-tab-${c.id}`}
          className={`whitespace-nowrap text-sm px-4 py-2 rounded-full ${collView === c.id ? "bg-[#291B2D] text-white" : "bg-[#F7F2EA] text-[#291B2D]"}`}>{c.title.split(":")[0]}</button>
      ))}
    </div>
  );
}
